import { useMemo } from "react";
import { useSelector } from "react-redux";

const useHotType = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { favoriteGameList = [] } = isHandleAllGame || {};

  const hotType = useMemo(() => {
    return [
      {
        type: "HOT",
        label: "熱門",
        hash: "Popular",
      },
      {
        type: "NEW",
        label: "最新",
        hash: "New",
      },
      {
        type: "EXCU",
        label: "MyFavorite",
        hash: "favoriteGameList",
        text: "FavoriteGame",
        hidden: favoriteGameList?.length === 0,
      },
    ];
  }, [favoriteGameList]);

  return { hotType: hotType.filter((item) => !item.hidden) };
};

export default useHotType;
